import { Component, OnInit, Output, EventEmitter,ViewChild,TemplateRef } from '@angular/core';
import { LogService } from '../../../_shared/log.service'
import { StreamService } from '@app/_services/masters/stream.service';
import { first } from 'rxjs/operators';
import { stream } from '@app/_models/stream';
import { Subject } from 'rxjs';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-stream-master',
  templateUrl: './stream-master.component.html',
  styleUrls: ['./stream-master.component.css']
})
export class StreamMasterComponent implements OnInit {
  dtTrigger: Subject<any> = new Subject<any>();
  stream: stream[];
  title = 'docVerificationList';
  dtOptions: DataTables.Settings = {};
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('showModalDeleteBox', { read: TemplateRef }) showModalDeleteBoxTemplate: TemplateRef<any>;
  getresponse: any;
  streamId: number;
  delMessage: string;

  constructor(private modalService: NgbModal, config: NgbModalConfig,  private eventService: LogService, private streamService: StreamService) { }

  callRoute(dataValue) {
    this.eventService.emit<string>(dataValue)
  }
  passData(dataValue, data) {
    //this.eventService.emit<any>(dataValue);
    this.eventService.emit({ dataValue, data });

  }
  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };
    this.streamService.getStream()
      .pipe(first())
      .subscribe(
        data => {
          console.log("Stream response---", data)
          this.stream = data.respData;
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )
  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('7');
  }

  deleteStream(id) {
    this.streamId = id;
    this.modalService.open(this.showModalDeleteBoxTemplate);
  }

  deleteStrm() {
    this.streamService.deleteStream(this.streamId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("Stream response---", data)
          this.getresponse = data;

          if (this.getresponse.respMessage == "Success") {
            this.delMessage="Stream Deleted Successfully."
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.open(this.showModalBoxTemplate);
            this.streamService.getStream()
              .pipe(first())
              .subscribe(
                data => {
                  console.log("Stream response---", data)
                  this.stream = data.respData;
                  //this.dtTrigger.next();
                },
                error => {
                  console.log(error)
                }
              )
          }
          else if (this.getresponse.respMessage == "Failure") {
            this.delMessage=this.getresponse.respData;
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.dismissAll(this.showModalBoxTemplate);
          }
          //this.modalService.dismissAll(this.showModalDeleteBoxTemplate);

          // this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )
  }



}
